export enum PermissionCode {
  SUPER_ADMIN = 'SUPER_ADMIN',
  // social
  BANNER_SOCIAL_ACCESS = 'BANNER_SOCIAL_ACCESS',
  BANNER_SOCIAL_VIEW = 'BANNER_SOCIAL_VIEW',
  BANNER_SOCIAL_ADD = 'BANNER_SOCIAL_ADD',
  BANNER_SOCIAL_EDIT = 'BANNER_SOCIAL_EDIT',
  BANNER_SOCIAL_DELETE = 'BANNER_SOCIAL_DELETE',
  BANNER_SOCIAL_STATUS = 'BANNER_SOCIAL_STATUS',
  // shop
  BANNER_SHOP_ACCESS = 'BANNER_SHOP_ACCESS',
  BANNER_SHOP_VIEW = 'BANNER_SHOP_VIEW',
  BANNER_SHOP_ADD = 'BANNER_SHOP_ADD',
  BANNER_SHOP_EDIT = 'BANNER_SHOP_EDIT',
  BANNER_SHOP_DELETE = 'BANNER_SHOP_DELETE',
  BANNER_SHOP_STATUS = 'BANNER_SHOP_STATUS',
  // food
  BANNER_FOOD_ACCESS = 'BANNER_FOOD_ACCESS',
  BANNER_FOOD_VIEW = 'BANNER_FOOD_VIEW',
  BANNER_FOOD_ADD = 'BANNER_FOOD_ADD',
  BANNER_FOOD_EDIT = 'BANNER_FOOD_EDIT',
  BANNER_FOOD_DELETE = 'BANNER_FOOD_DELETE',
  BANNER_FOOD_STATUS = 'BANNER_FOOD_STATUS',
  // travel
  BANNER_TRAVEL_ACCESS = 'BANNER_TRAVEL_ACCESS',
  BANNER_TRAVEL_VIEW = 'BANNER_TRAVEL_VIEW',
  BANNER_TRAVEL_ADD = 'BANNER_TRAVEL_ADD',
  BANNER_TRAVEL_EDIT = 'BANNER_TRAVEL_EDIT',
  BANNER_TRAVEL_DELETE = 'BANNER_TRAVEL_DELETE',
  BANNER_TRAVEL_STATUS = 'BANNER_TRAVEL_STATUS',
  // hotel
  BANNER_HOTEL_ACCESS = 'BANNER_HOTEL_ACCESS',
  BANNER_HOTEL_VIEW = 'BANNER_HOTEL_VIEW',
  BANNER_HOTEL_ADD = 'BANNER_HOTEL_ADD',
  BANNER_HOTEL_EDIT = 'BANNER_HOTEL_EDIT',
  BANNER_HOTEL_DELETE = 'BANNER_HOTEL_DELETE',
  BANNER_HOTEL_STATUS = 'BANNER_HOTEL_STATUS',
  // car
  BANNER_CAR_ACCESS = 'BANNER_CAR_ACCESS',
  BANNER_CAR_VIEW = 'BANNER_CAR_VIEW',
  BANNER_CAR_ADD = 'BANNER_CAR_ADD',
  BANNER_CAR_EDIT = 'BANNER_CAR_EDIT',
  BANNER_CAR_DELETE = 'BANNER_CAR_DELETE',
  BANNER_CAR_STATUS = 'BANNER_CAR_STATUS',
  // flight
  BANNER_FLIGHT_ACCESS = 'BANNER_FLIGHT_ACCESS',
  BANNER_FLIGHT_VIEW = 'BANNER_FLIGHT_VIEW',
  BANNER_FLIGHT_ADD = 'BANNER_FLIGHT_ADD',
  BANNER_FLIGHT_EDIT = 'BANNER_FLIGHT_EDIT',
  BANNER_FLIGHT_DELETE = 'BANNER_FLIGHT_DELETE',
  BANNER_FLIGHT_STATUS = 'BANNER_FLIGHT_STATUS',
  //membership
  BANNER_MEMBERSHIP_ACCESS = 'BANNER_MEMBERSHIP_ACCESS',
  BANNER_MEMBERSHIP_VIEW = 'BANNER_MEMBERSHIP_VIEW',
  BANNER_MEMBERSHIP_ADD = 'BANNER_MEMBERSHIP_ADD',
  BANNER_MEMBERSHIP_EDIT = 'BANNER_MEMBERSHIP_EDIT',
  BANNER_MEMBERSHIP_DELETE = 'BANNER_MEMBERSHIP_DELETE',
  BANNER_MEMBERSHIP_STATUS = 'BANNER_MEMBERSHIP_STATUS',
}
